import {Component, inject} from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {LocaleService} from "../../../../locale/locale.service";
import {FinishBoxComponent} from "../../../common/finish-box/finish-box.component";
import {ClaimsService} from "../../../../services/claims.service";
import {FormNavigationService} from '../../../../services/form-navigation/form-navigation.service';
import { NavigationKey } from '../../../../enums/navigation-key-type';
import { ColoredBackgroundComponent } from '../../../common/colored-background/colored-background.component';

@Component({
  selector: 'app-accident-report-finished',
  imports: [
    ColoredBackgroundComponent,
    FooterComponent,
    HeaderComponent,
    FinishBoxComponent
  ],
  templateUrl: './accident-report-finished.component.html',
  styleUrl: './accident-report-finished.component.css'
})
export class AccidentReportFinishedComponent {
    locale = inject(LocaleService);
    claimsService = inject(ClaimsService);
    private formNavigationService = inject(FormNavigationService);

  navigateNextPage() {
    this.formNavigationService.navigate(NavigationKey['accident-report-finished']);
  }
}
